import { spawn, call, takeLatest, put, all } from 'redux-saga/effects';

// Actions
import { generarDesafioCPAction } from '../../../../application/actions/generarDesafioCP';

import { loadersActions } from '../../../../application/actions/ui_loaders';

// import { logReqError } from '../../../ui/utils/functions';

import api from '../../../api';
const apiGenerarDesafioCP = api(process.env.REACT_APP_URL);

export function* fetchGenerarCP(params) {
  try {
    
    const { autorizacion, trackid } = params.payload;

    yield put(loadersActions.changeStatusLoader({ isLoading: true }));

    //Hacemos la llamada al servicio
    const { data } = yield call(apiGenerarDesafioCP.post,'/desafio/softtoken/generar', '' , { 
         'Track-Id': trackid,
        'Authorization': autorizacion
     });


    yield put(loadersActions.changeStatusLoader({ isLoading: false }));

    if (data) {
      yield put(generarDesafioCPAction.fetchGenerarDesafioCPSuccess({ respuestaServicio: data }));

    } else {
      yield put(generarDesafioCPAction.fetchGenerarDesafioCPError());

    }

  } catch {
      //Errores
    yield all([
      put(generarDesafioCPAction.fetchGenerarDesafioCPError())
    ]);
  }
}

export function* watchFetchGenerarCP() {
  yield takeLatest(generarDesafioCPAction.fetchGenerarDesafioCP.type, fetchGenerarCP);
}

export default function* rootSaga() {
  yield spawn(watchFetchGenerarCP);
}
